import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import { seriesCategoryNav } from '@shared-submodule/sm-constants/allNavBars'
import Layout from '../layout'
import { navLoader, pageHeaderLoader } from '@shared/libs/allLoader'
import { ENUM_SERIES_CATEGORY_PAGES } from '@shared-submodule/sm-enum'
import { arraySortByOrder } from '@shared-submodule/utils'
// import CurrentSeries from '../widgets/currentSeries'
// import RankingTab from '../rankingTab'
// import SBSpecial from '../sbSpecial'
// import FantasyTipsWidget from '../fantasyTipsWidget'
import LazyLoad from '../lazyLoad'
import StaticBanner from '../staticBanner'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import { skyAddData } from '@shared/constants/skyAds'
import useWindowSize from '@shared/hooks/windowSize'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const PageHeader = dynamic(() => import('@shared/components/pageHeader'), { loading: () => pageHeaderLoader() })
const CommonNav = dynamic(() => import('@shared/components/commonNav'), { loading: () => navLoader() })
const ClientCommonNav = dynamic(() => import('@shared/components/commonNav/client'), { loading: () => navLoader() })
const UpcomingMatches = dynamic(() => import('../widgets/upcomingMatches'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })
const CategoryContent = ({
  seoData,
  children,
  category,
  isFantasyArticle,
  showNav,
  tabSeo,
  reWriteURLS,
  tab,
  scoreCard,
  ssrNav,
  currentSeriesData,
  rankingTabData
}) => {
  const router = useRouter()
  const { tab: routerTab } = router.query || {}
  const getActiveTab = (tab) => {
    const normalizedTab = Array.isArray(tab) ? tab[0] : tab
    if (normalizedTab) {
      return normalizedTab
    } else {
      return 'home'
    }
  }
  const onChangeTab = useCallback((newTab) => {
    newTab = newTab.toLowerCase()
    if (newTab === 'home') {
      router.push(router.asPath.split('?')[0], undefined, { shallow: true })
    } else {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, tab: newTab }
      }, undefined, { shallow: true })
    }
  }, [router.asPath, router.pathname, router.query])

  const activeTab = getActiveTab(routerTab)

  const [width] = useWindowSize()
  const isIpl = category?._id === '623184adf5d229bacb00ff63'
  const tagLine = {
    fixtures: 'The below-mentioned fixtures are of IPL 2022. The fixtures for IPL 2023 will be added once announced',
    standings: 'The below-mentioned point table is from IPL 2022. The IPL 2023 standings will be added once the tournament starts',
    stats: 'The below-mentioned stats are from IPL 2022. The IPL 2023 numbers will be added once the league starts'
  }

  function getNavItems() {
    const items = []
    ssrNav?.forEach(t => {
      if (ENUM_SERIES_CATEGORY_PAGES[t?.eSubType] && t?.eSubType !== 'ft') {
        items.push({
          navItem: ENUM_SERIES_CATEGORY_PAGES[t?.eSubType].replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      } else if (t?.eSubType === null) {
        // Home Tab
        items.push({
          navItem: ENUM_SERIES_CATEGORY_PAGES.h.replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      }
    })
    const order = ['home', 'news', 'videos', 'fixtures', 'standings', 'stats', 'teams', 'squads', 'archives', 'fantasy tips']
    return arraySortByOrder({ data: items, order, key: 'navItem' })
  }
  function getNav() {
    if (showNav) {
      if (
        category?.eType === 'gt' ||
        category?.eType === 'pct' ||
        category?.eType === 't' ||
        category?.eType === 's' ||
        category?.eType === 'fac' ||
        category?.eType === 'p'
      ) {
        return (
          <ClientCommonNav
            items={seriesCategoryNav({
              isSeries: category?.eType
            })}
            active={activeTab}
            onTabChange={onChangeTab}
          />
        )
      } else {
        return (
          <>
            <CommonNav items={getNavItems()} />
          </>
        )
      }
    }
  }

  const getTitleDesc = () => {
    let tabData = {}
    ssrNav?.forEach(cat => {
      if (seoData?.eSubType === cat?.eSubType) {
        tabData = cat
      }
    })
    return tabData
  }

  const getSubPagesDetail = getTitleDesc()
  const { mobSm, addRight, addTop, addBottom, addLeft, add300 } = reviveAdData
  const randomAd = Math.random() < 0.5 ? addLeft : add300

  return (
    <Layout
      data={{
        ...category,
        sTitle: category?.sName,
        oSeo: seoData
      }}
      scoreCard={category?.eType === 'as' ? scoreCard : undefined}>
      <main className="pt-4 mb-4">
        <ATSAds />
        <Container>
          <Row>
            <Col xl={8} xxl={9} className="left-content">
              <PageHeader
                name={getSubPagesDetail?.sDTitle || category?.sName}
                favBtn
                type={category?.eType}
                id={seoData?.iId}
                isFavorite={category?.bIsFav}
                isFantasyArticle={isFantasyArticle}
                category={category}
                showHeaderImg={category?.eType === 'as'}
                isSeries
              />
              <div className="w-full d-none d-xl-flex justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.addTop?.addId}
                  divId={googleAddData?.addTop?.divId}
                  dimension={googleAddData?.addTop?.dimension}
                  slotId={googleAddData?.addTop?.slotId}
                  className={'m-0'}
                /> */}
                <ReviveAds {...addTop} className={'m-0'}/>
              </div>
              <div className="w-full d-flex d-xl-none justify-content-center">
                {/* <GoogleAds
                  addId={googleAddData?.mobSm?.addId}
                  divId={googleAddData?.mobSm?.divId}
                  dimension={googleAddData?.mobSm?.dimension}
                  slotId={googleAddData?.mobSm?.slotId}
                  className={'mt-2'}
                /> */}
                <ReviveAds {...mobSm} className={'mt-2'}/>
              </div>
              {/* <StaticBannerSecond adType="secondAd_long" link="series_top_banner" /> */}
              {getNav()}
              {isIpl && (
                <p className="text-uppercase">
                  <u>
                    <b>{tagLine[tab]}</b>
                  </u>
                </p>
              )}
              {children({ activeTab, changeTab: onChangeTab })}
              {width > 1400 &&
            // <GoogleAds
            //       addId={skyAddData?.addBottom?.addId}
            //       divId={skyAddData?.addBottom?.divId}
            //       dimension={skyAddData?.addBottom?.dimension}
            //       slotId={skyAddData?.addBottom?.slotId}
            //       className={'my-3'}
            //     />
            <ReviveAds {...addBottom} className={'my-3 text-center'}/>
            }
             {width < 1000 &&
            // <GoogleAds
            //       addId={skyAddData?.addRight?.addId}
            //       divId={skyAddData?.addRight?.divId}
            //       dimension={skyAddData?.addRight?.dimension}
            //       slotId={skyAddData?.addRight?.slotId}
            //       className={'my-3'}
            //     />
            <ReviveAds {...randomAd} className={'d-flex justify-content-center my-3'}/>
            }
            </Col>
            <Col xl={4} xxl={3} className="common-sidebar isDesk">
              {/* <SBSpecial /> */}
              <LazyLoad>
                <StaticBanner isLeft />
                <UpcomingMatches />
                {/* <StaticBannerSecond adType="secondAd_Rect" link="series_left_banner" /> */}
                {/* <GoogleAds
                  addId={googleAddData?.addRight?.addId}
                  divId={googleAddData?.addRight?.divId}
                  dimension={googleAddData?.addRight?.dimension}
                  slotId={googleAddData?.addRight?.slotId}
                  className={'mt-0 sticky_ads'}
                /> */}
                <ReviveAds {...add300} className={'mb-2'}/>
                <ReviveAds {...addRight} className={'d-flex justify-content-center mt-0 sticky_ads'}/>
                {/* <FantasyTipsWidget /> */}
              </LazyLoad>
            </Col>
            <div className="d-md-none">
              {/* <StaticBannerSecond adType="secondAdRect_Left" link="series_bottom_mweb_banner" /> */}
              <StaticBanner isLeft />
            </div>
          </Row>
        </Container>
      </main>
    </Layout>
  )
}
CategoryContent.propTypes = {
  seoData: PropTypes.object,
  category: PropTypes.object,
  children: PropTypes.func,
  isFantasyArticle: PropTypes.bool,
  showNav: PropTypes.bool,
  tabSeo: PropTypes.object,
  reWriteURLS: PropTypes.array,
  scoreCard: PropTypes.array,
  tab: PropTypes.string,
  ssrNav: PropTypes.array,
  currentSeriesData: PropTypes.object,
  rankingTabData: PropTypes.object
}

export default CategoryContent
